module.exports = __webpack_public_path__ + "img/icb-del-elite-m.5f1ae39e.png";